import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useEventSchedule } from '~/features/home/queries/useMainInfo'
import Calendar from '~/shared/assets/icons/Calendar'
import Close from '~/shared/assets/icons/Close'
import Info from '~/shared/assets/icons/Info'
import Location from '~/shared/assets/icons/Location'
import Star from '~/shared/assets/icons/Star'
import { isModalOpenState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function ScheduleModal() {
  const [_, setIsModalOpen] = useRecoilState(isModalOpenState)

  const { data: eventSchedule } = useEventSchedule()

  return (
    <Wrapper>
      <CloseIcon
        onClick={() => setIsModalOpen({ contents: '', isOpen: false })}
      />
      <Title>COMING UP 2024</Title>

      <Container>
        {eventSchedule?.data.scheduleList.map((schedule) => {
          return (
            <ScheduleBox>
              <StarIcon color={theme.colors.mint_3} />
              <div className="event_name">{schedule.event_name}</div>
              <div className="event_box">
                <img
                  src={eventSchedule?.data.scheduleList[0].image_info.url}
                  alt=""
                  className="logo"
                />
                <div className="content_box">
                  <div className="content">
                    <Calendar />
                    {schedule.event_date}
                  </div>
                  <div className="content">
                    <Location />
                    {schedule.event_location}
                  </div>
                  <div className="content">
                    <Info />
                    {schedule.event_desc}
                  </div>
                </div>
              </div>
            </ScheduleBox>
          )
        })}
      </Container>
    </Wrapper>
  )
}

export default ScheduleModal

const Wrapper = styled.section`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  top: 50%;
  right: 0;
  transform: translate(0, -50%);

  overflow: visible scroll;
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 640px;
  height: 100vh;
  margin: 0 auto;
  padding: 108px 77px 60px;

  background-color: ${theme.colors.white};

  @media ${theme.device.medium} {
    gap: 24px;
    width: 100vw;
    height: 100vh;
    padding: 60px 40px;
  }
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 40px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 700;
  font-style: normal;
  line-height: 140%;
  color: #313634;
  text-transform: uppercase;

  @media ${theme.device.medium} {
    font-size: 36px;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const ScheduleBox = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 16px;

  box-sizing: border-box;
  width: 80%;
  height: 230px;
  padding-left: 36px;

  border-left: 2px solid ${theme.colors.mint_2};

  .event_name {
    font-family: NanumSquareNeo-Bold, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
  }

  .event_box {
    display: flex;
    gap: 24px;

    box-sizing: border-box;
    width: 460px;
    height: 144px;
    padding: 20px;

    border: 1px solid ${theme.colors.grey_3};
    border-radius: 12px;

    .logo {
      width: 40%;
      height: auto;
      object-fit: cover;
    }

    @media ${theme.device.medium} {
      width: 100%;
    }
  }

  .content_box {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .content {
    display: flex;
    gap: 4px;
    align-items: center;
    font-size: 16px;

    @media ${theme.device.medium} {
      font-size: 12px;
    }
  }

  @media ${theme.device.medium} {
    width: 100%;
  }
`

const StarIcon = styled(Star)`
  position: absolute;
  top: -16px;
  left: -17px;

  background-color: ${theme.colors.mint_3};
  border-radius: 50%;
`
